import * as React from 'react';
import { Marker } from 'google-maps-react';

class CustomMarker extends Marker {
    componentDidUpdate(prevProps: any) {
        if (
            this.props.map !== prevProps.map ||
            (this.props.icon as any).url !== prevProps.icon.url ||
            (
                this.props.position.lat !== prevProps.position.lat ||
                this.props.position.lng !== prevProps.position.lng
            )
        ) {
            if ((this as any).marker) {
                (this as any).marker.setMap(null);
            }

            (this as any).renderMarker();
        }
    }
}

export default CustomMarker;